import { graphql } from "react-relay";

export const RemoveSAMLProviderMutation = graphql`
  mutation RemoveSAMLProviderMutation($input: RemoveSAMLProviderInput!) {
    removeSAMLProvider(input: $input) {
      problems {
        message
      }
      removed {
        id @deleteRecord
      }
    }
  }
`;
